module.exports = __webpack_public_path__ + "static/media/conocephalus_fuscus.80502908.jpg";